import React from 'react'
import image from '../../../assets/homepage_pro7.png'
const LowerBannerTwo = () => {
    return (
        <>
            <div className="cate-bx2 common align-items-center">
                <div className="cate-txt">
                    <h3>
                        <span>LEST’S Build you PC</span> WITH AWESOME TOOL
                    </h3>
                    <a href="#" className="btn-buy">
                        Shop Now
                    </a>
                </div>
                <div className="bx-img">
                    <img className="img-fluid" src={image} alt="" />
                </div>
            </div>

        </>
    )
}

export default LowerBannerTwo